import React from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function Help() {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="header_top gb bg_sky">
        <div className="inner">
          <div className="btns_wrap cls">
            <div className="app_btn">
              <button
                className="btn_exit"
                type="button"
                onClick={() => history.goBack()}
              >
                <img src="./static/images/icon/btn_back.svg" alt="" />
              </button>
            </div>
            <div className="tit_gm center_tit24">{t("MY_04_03.msg006")}</div>
          </div>
        </div>
      </div>

      <div className="layout-def with_header cs_mail">
        <div className="container">
          <div className="inner">
            <div dangerouslySetInnerHTML={{ __html: t("MY_04_03.msg001")}} />
            {/* <div className="txt1">궁금한점이나 개선사항이 필요한 사항에 대해<br />고객님의 소중한 의견을 보내주세요.</div>
            <div className="txt2">우선 접수된 문의 건부터 순차적으로 상담이 진행되며 <br className="hide_pc hide_t" />답변은 24시간 이상 소요될 수 있습니다.</div> */}
            <div className="mail">
              <a href="mailto:mathpid@wjtb.net">mathpid@wjtb.net</a>
              {/* <A style={{textDecoration: 'none'}}>mathpid@wjtb.net</A> */}
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default Help;